var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.827.743h28.5a4.75 4.75 0 0 1 4.75 4.75v14.25a4.75 4.75 0 0 1-4.75 4.75h-28.5a4.75 4.75 0 0 1-4.75-4.75V5.493a4.75 4.75 0 0 1 4.75-4.75Zm32.25 4.75a3.75 3.75 0 0 0-3.75-3.75h-28.5a3.75 3.75 0 0 0-3.75 3.75v14.25a3.75 3.75 0 0 0 3.75 3.75h28.5a3.75 3.75 0 0 0 3.75-3.75V5.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.077 10.113h2v5h-1.34v-3.3l-1.53 3.3h-1.21l-1.67-3.6v3.6h-2.5l-.47-1.11h-2.34l-.45 1.11h-1.49l2.18-5h1.9l1.92 4.22v-4.22h2l1.5 3.19 1.5-3.19Zm-7.91 1.09-.68 1.66h1.39l-.71-1.66ZM29.317 10.113h1.76l-2.31 2.5 2.31 2.5h-1.77l-1.44-1.57-1.47 1.57h-5.4v-5h5.51l1.39 1.5 1.42-1.5Zm-4.24 3.85v.65l1.93-2-1.93-2.12v.76h-2.8v.79h2.8v1.13h-2.8v.79h2.8Z"
  }))));
};
export default SvgAmex;